import IntroSmall from '@/Framework/UI/Pages/Landing/Sections/IntroSmall';
import styles from './intro.scss';

const Intro = () => (
  <IntroSmall
    className={ styles.intro }
    title="Regulations for equity Pre-IPO research distribution"
    description="A brief handbook summarizing regulations and guidance for syndicate and research desks in EMEA and APAC."
  />
);

export default Intro;
